import {
    CustomBodyCell,
    CustomHeaderCell,
    CustomTable,
    CustomTableContainer,
    CustomTableRow,
  } from '@components/Styles/TableStyle';
  import { CustomStack, CustomTextField, SectionWrapper } from '@components/Styles/CommonStyle';
  import { TableBody, Typography } from '@mui/material';
  
  import { CustomButton } from '@components/Styles/ButtonStyle';
  import React, { forwardRef, useImperativeHandle, useState } from 'react';
  import { theme } from '@components/Styles/theme';
  
  const PlannedProjectSearchV2 = forwardRef(({  
    onSearch,
  }, ref) => {
    // 검색 : 동적 파라미터
    const [search, setSearch] = useState({
      projectName: '',
      orderingCompanyName: '',
      accountCompanyName: '',
      projectManagerName: '',
      isProjectConfirm: false,
      orderBy: 'start_date',
      orderDir: 'ASC',
    });

    useImperativeHandle(ref, () => ({
      getSearch: () => {
        return search;
      },
      setSearch: (newSearch) => {
        setSearch(newSearch);
      },
    }));
  
    return (
      <React.Fragment>
        <SectionWrapper>
          <CustomStack mb={2}>
            <Typography sx={theme.typography.h4}>검색</Typography>
          </CustomStack>
          <CustomTableContainer>
            <CustomTable fourColumn>
              <TableBody>
                <CustomTableRow>
                  <CustomHeaderCell>사업명</CustomHeaderCell>
                  <CustomBodyCell>
                    <CustomTextField
                      size="small"
                      placeholder="사업명"
                      value={search.projectName}
                      onChange={(e) => setSearch({ ...search, projectName: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          onSearch(1, true);
                        }
                      }}
                    />
                  </CustomBodyCell>
                  <CustomHeaderCell>발주사</CustomHeaderCell>
                  <CustomBodyCell>
                    <CustomTextField
                      size="small"
                      placeholder="발주사"
                      value={search.orderingCompanyName}
                      onChange={(e) => setSearch({ ...search, orderingCompanyName: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          onSearch(1, true);
                        }
                      }}
                    />
                  </CustomBodyCell>
                </CustomTableRow>
                <CustomTableRow>
                  <CustomHeaderCell>거래처</CustomHeaderCell>
                  <CustomBodyCell>
                    <CustomTextField
                      size="small"
                      placeholder="거래처"
                      value={search.accountCompanyName}
                      onChange={(e) => setSearch({ ...search, accountCompanyName: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          onSearch(1, true);
                        }
                      }}
                    />
                  </CustomBodyCell>
                  <CustomHeaderCell>사업담당자</CustomHeaderCell>
                  <CustomBodyCell>
                    <CustomTextField
                      size="small"
                      placeholder="사업담당자"
                      value={search.projectManagerName}
                      onChange={(e) => setSearch({ ...search, projectManagerName: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          onSearch(1, true);
                        }
                      }}
                    />
                  </CustomBodyCell>
                </CustomTableRow>
              </TableBody>
            </CustomTable>
          </CustomTableContainer>
          <CustomStack justifyContent="center" mt={2}>
            <CustomButton type="search" onClick={() => onSearch(1, true)}>
              검색
            </CustomButton>
          </CustomStack>
        </SectionWrapper>
      </React.Fragment>
    );
  });
  
  export default PlannedProjectSearchV2;
  